const data = [
  {
    imgelink:
      "https://i.guim.co.uk/img/media/e56bb5d2ff7a1efcde76853ecefce5a7c9834f54/0_0_1506_1068/master/1506.jpg?width=700&quality=85&auto=format&fit=max&s=1b3415a893135acd189d947c11efe862",
  },
  
    {
      imgelink:
        "https://i0.wp.com/cittaindia.org/wp-content/uploads/2022/12/girls-sitting-on-well-1800x1000-FTT.jpg?resize=1024%2C569&ssl=1",
    },
    {
      imgelink:
        "https://www.squareyards.com/blog/wp-content/uploads/2022/04/Elevated-Walkways-with-Perforated-Walls.jpg",
    },
    {
      imgelink:
        "https://www.squareyards.com/blog/wp-content/uploads/2022/04/Recessed-Circular-Spaces-within-Walls.jpg",
    },
    {
      imgelink:
        "https://assets.vogue.in/photos/5f8687d22ed1c0784ab7b016/1:1/w_2999,h_2999,c_limit/Sabyasachi%20Ajrakh%20uniforms.jpeg",
    },
    {
      imgelink:
        "https://i0.wp.com/cittaindia.org/wp-content/uploads/2023/02/w_vazquez_citta-4895-2400x1200-1.jpg?fit=2400%2C1200&ssl=1",
    },
  ];
  export default data;